// Product types

export const LOAD_SKUS_TO_STATE = 'LOAD_SKUS_TO_STATE';
